import { useNode } from '@craftjs/core';
import { ImageBlockPanel, LayoutPanel, LogicPanel, StylesPanel } from 'src/features/generalForms/builder/layout/panels';
import { FormImageComponent } from 'src/features/generalForms/builder/types/Image';
import { useScopedTranslation } from 'src/application/localisation/useScopedTranslation';
import { LoadResourceBlock } from 'src/features/generalForms/builder/helpers/loadResourceComponent/loadResourceComponent';
import ImageIconPlaceholder from 'assets/img/generalBuilder/image_placeholder_64.svg';
import { useCallback, useState } from 'react';
import { useFieldAttachments } from 'src/features/generalForms/context/attachments.provider';

export const ImageBlock: FormImageComponent = () => {
  const {
    connectors: { connect, drag },
    styles,
  } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const { t } = useScopedTranslation('GeneralFormBuilder.Panels.ImageBlock');
  const { attachment, imageUrl, loading, onChange, errorMessage } = useFieldAttachments();

  const [localError, setLocalError] = useState<string>();
  const errorHandler = useCallback(
    (event: any) => {
      // eslint-disable-next-line no-console
      console.error(
        `Error during loading image for "ImageBlock" with source ${event?.target?.currentSrc}`,
        new Error(event),
      );
      setLocalError(t('Error'));
    },
    [t],
  );

  const loadHandler = useCallback(() => {
    setLocalError('');
  }, []);

  return (
    <div ref={(ref) => connect(drag(ref!))} style={styles}>
      <LoadResourceBlock
        addButtonText={t('Resource.Add')}
        changeButtonText={t('Resource.Change')}
        placeholderImg={ImageIconPlaceholder}
        error={localError ?? errorMessage}
        isLoading={loading}
        onChange={onChange}
        value={attachment}
      >
        <img
          alt={'Custom image'}
          src={imageUrl}
          style={{ width: '100%' }}
          onError={errorHandler}
          onLoad={loadHandler}
        />
      </LoadResourceBlock>
    </div>
  );
};

export const ImageBlockSettings = () => {
  return (
    <>
      <ImageBlockPanel />
      <LayoutPanel sections={['Dimension', 'Paddings']} />
      <StylesPanel sections={['Border']} />
      <LogicPanel sections={['Visible']} />
    </>
  );
};

ImageBlock.craft = {
  displayName: 'ImageBlock',
  rules: { canDrag: () => true },
  related: { settings: ImageBlockSettings },
};
